
namespace RedBullMOBILE360.AutomaticReports {

    @Serenity.Decorators.registerClass()
    export class ReportLogDialog extends Serenity.EntityDialog<ReportLogRow, any> {
        protected getFormKey() { return ReportLogForm.formKey; }
        protected getIdProperty() { return ReportLogRow.idProperty; }
        protected getLocalTextPrefix() { return ReportLogRow.localTextPrefix; }
        protected getNameProperty() { return ReportLogRow.nameProperty; }
        protected getService() { return ReportLogService.baseUrl; }
        protected getDeletePermission() { return ReportLogRow.deletePermission; }
        protected getInsertPermission() { return ReportLogRow.insertPermission; }
        protected getUpdatePermission() { return ReportLogRow.updatePermission; }

        protected form = new ReportLogForm(this.idPrefix);

    }
}